import React from "react";
import { FaRegClock, FaRegEnvelope } from "react-icons/fa6";
import { GoGlobe } from "react-icons/go";
import { IoCallOutline } from "react-icons/io5";
import { LuBuilding } from "react-icons/lu";
import { LuUsers } from "react-icons/lu";
import { MdOutlineCalendarMonth } from "react-icons/md";
import { useDispatch } from "react-redux";
import { setModal } from "../features/modal/ModalSlice";
import { Link } from "react-router-dom";

const CompanyProfile = () => {
  const dispatch = useDispatch();

  const handelChangeEmailPoup = () => {
    dispatch(setModal({ type: "CHANGE_EMAIL" }));
  };

  return (
    <>
      <div className="pageTitle1 py-4 px-5">
        <h3 className="mb-2">Settings</h3>
        <p className="m-0">Manage you general information</p>
      </div>

      <div className="p-5">
        <div className="profilePage">
          <div className="row">
            <div className="col-xl-12">
              <div className="pickName">
                <figure className="mb-0 me-4">
                  <img src="../Images/profile-icon.png" alt="profileicon" />
                </figure>
                <div className="nameDtl">
                  <h3 className="m-0">Source Soft Solutions</h3>
                  <p className="m-0">info@sourcesoftsolutions.com</p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <h3 className="subTitle mb-3">Profile</h3>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <LuBuilding />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Name</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <IoCallOutline />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Phone Number</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <GoGlobe />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Domain</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <LuUsers />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Number of employees</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <MdOutlineCalendarMonth />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Date, time and date format</label>
              </div>
            </div>

            <div className="col-xl-5">
              <div className="inputData withIcon my-3">
                <span className="icon">
                  <FaRegClock />
                </span>
                <input type="text" name="firstname" className="form-control my-2" required />
                <label htmlFor="firstname">Working hours</label>
              </div>
            </div>

            <div className="col-10 mt-4">
              <div className="changeEmail px-3 py-2 rounded-2 d-flex justify-content-between align-items-center">
                <p className="m-0">
                  <span className="me-2">
                    <FaRegEnvelope />
                  </span>
                  info@sourcesoftsolutions.com
                </p>
                <Link onClick={handelChangeEmailPoup}>Change email</Link>
              </div>
            </div>

            <div className="col-10">
              <div className="d-flex gap-4 py-5 taskModal justify-content-end">
                <button className="btnNobg py-2">Cancel</button>
                <button className="btnSubmit py-2">Save</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyProfile;
